import { render, staticRenderFns } from "./UserRoleList.vue?vue&type=template&id=3cc7e6df&scoped=true"
import script from "./UserRoleList.vue?vue&type=script&lang=js"
export * from "./UserRoleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7e6df",
  null
  
)

export default component.exports